import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "px-3" }
const _hoisted_3 = { class: "px-3" }
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = { class: "font-bold" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Products ")
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 1,
  class: "font-bold"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Catalog option", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Your product option")
const _hoisted_13 = {
  key: 0,
  class: "font-bold"
}
const _hoisted_14 = {
  key: 1,
  class: "font-bold"
}
const _hoisted_15 = { class: "font-bold" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Select products ")
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "text-base my-3" }
const _hoisted_19 = { class: "capitalize tex-xl font-bold" }
const _hoisted_20 = { class: "capitalize tex-xl font-bold" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode("  Save ")
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_slot_error = _resolveComponent("slot-error")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(_component_el_row, { gutter: 20 }, {
    default: _withCtx(() => [
      _createVNode(_component_el_col, { span: 8 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_card, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_el_image, {
                    style: {"width":"100px","height":"auto"},
                    src: _ctx.imageUrl(_ctx.products[0].mockup),
                    "preview-src-list": [_ctx.imageUrl(_ctx.products[0].mockup)],
                    "initial-index": 1
                  }, {
                    error: _withCtx(() => [
                      _createVNode(_component_slot_error)
                    ]),
                    _: 1
                  }, 8, ["src", "preview-src-list"])
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.products[0].title), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.products[0].variants.length) + " variants", 1)
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_card, { class: "mt-3" }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  (_ctx.state.optionsMapping[0].optionValues.length > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, " (" + _toDisplayString(_ctx.state.optionsMapping[0].optionValues.length) + ") ", 1))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_el_divider),
                (
              _ctx.state.optionsMapping &&
              _ctx.state.optionsMapping.length > 0 &&
              _ctx.state.optionsMapping[0].optionValues.length > 0 &&
              !_ctx.state.optionsMapping[0].mapWith.includes('default')
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.optionsMapping[0].optionValues, (mp, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass(["py-2", { 'font-bold': mp.selected }]),
                          onClick: ($event: any) => (_ctx.onSelectMappingProduct(mp)),
                          key: i
                        }, _toDisplayString(mp.option), 11, _hoisted_9))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.products[0].title), 1))
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_col, { span: 16 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, {
                    span: 12,
                    class: "my-3"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 12,
                    class: "font-bold my-3"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.optionsMapping, (oppMap, iopp) => {
                        return (_openBlock(), _createBlock(_component_el_row, { key: iopp }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, {
                              span: 12,
                              class: "my-3"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createElementVNode("b", null, _toDisplayString(oppMap.name), 1)
                                ]),
                                _createElementVNode("div", null, _toDisplayString(oppMap.des), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_el_col, {
                              span: 12,
                              class: "my-3"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  onChange: ($event: any) => (_ctx.onChangeMappingOption(iopp)),
                                  modelValue: oppMap.mapWith,
                                  "onUpdate:modelValue": ($event: any) => ((oppMap.mapWith) = $event),
                                  placeholder: `Select ${oppMap.value}`
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(oppMap.values, (option, i) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        value: option.value,
                                        label: option.name,
                                        key: i
                                      }, null, 8, ["value", "label"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["onChange", "modelValue", "onUpdate:modelValue", "placeholder"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_card, { class: "mt-3" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, {
                gutter: 24,
                class: "mt-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, {
                            span: 12,
                            class: "my-3"
                          }, {
                            default: _withCtx(() => [
                              (
                    _ctx.state.optionsMapping.length > 0 &&
                    _ctx.state.optionsMapping[0].optionValues.length > 0 &&
                    !_ctx.state.optionsMapping[0].mapWith.includes('default')
                  )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.state.optionsMapping[0].optionValues.find(o => o.selected)
                      .option), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.products[0].title), 1))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, {
                            span: 12,
                            class: "my-3"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_15, [
                                _hoisted_16,
                                (_ctx.catalogs.length > 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, " (" + _toDisplayString(_ctx.catalogs.length) + ") ", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_18, [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.stateTwo.catalogId,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.stateTwo.catalogId) = $event)),
                                  placeholder: "Select",
                                  filterable: ""
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.catalogs, (cat) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: cat._id,
                                        label: cat.name,
                                        value: cat._id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_divider),
                      (_ctx.state.catalog)
                        ? (_openBlock(), _createBlock(_component_el_row, {
                            key: 0,
                            gutter: 24
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                span: 24,
                                class: "my-3"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.optionsMapping, (mpo, i) => {
                                    return (_openBlock(), _createBlock(_component_el_row, { key: i }, {
                                      default: _withCtx(() => [
                                        (i !== 0)
                                          ? (_openBlock(), _createBlock(_component_el_col, {
                                              key: 0,
                                              span: 24
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_row, { class: "my-2" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_el_col, { span: 12 }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("div", _hoisted_19, _toDisplayString(mpo.mapWith), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_el_col, { span: 12 }, {
                                                      default: _withCtx(() => [
                                                        _createElementVNode("div", _hoisted_20, _toDisplayString(mpo.name), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                (mpo.mapWith.includes('default'))
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                      _createVNode(_component_el_row, { class: "my-2" }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_el_col, { span: 12 }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_el_checkbox, {
                                                                disabled: true,
                                                                label: `Default option`,
                                                                modelValue: mpo.optionValues[0].selected,
                                                                "onUpdate:modelValue": ($event: any) => ((mpo.optionValues[0].selected) = $event)
                                                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                            ]),
                                                            _: 2
                                                          }, 1024),
                                                          (_ctx.stateTwo.catalogId && _ctx.state.catalog)
                                                            ? (_openBlock(), _createBlock(_component_el_col, {
                                                                key: 0,
                                                                span: 12
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_el_select, {
                                                                    onChange: _ctx.onChangeOption,
                                                                    modelValue: mpo.optionValues[0].optionSet,
                                                                    "onUpdate:modelValue": ($event: any) => ((mpo.optionValues[0].optionSet) = $event),
                                                                    placeholder: `Select ${mpo.value}`
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.catalog[mpo.value], (cc) => {
                                                                        return (_openBlock(), _createBlock(_component_el_option, {
                                                                          key: cc,
                                                                          label: cc.name,
                                                                          value: cc.name
                                                                        }, null, 8, ["label", "value"]))
                                                                      }), 128))
                                                                    ]),
                                                                    _: 2
                                                                  }, 1032, ["onChange", "modelValue", "onUpdate:modelValue", "placeholder"])
                                                                ]),
                                                                _: 2
                                                              }, 1024))
                                                            : _createCommentVNode("", true)
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]))
                                                  : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mpo.optionValues, (ov, iov) => {
                                                        return (_openBlock(), _createBlock(_component_el_row, {
                                                          class: "my-2",
                                                          key: iov
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_el_col, { span: 12 }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_el_checkbox, {
                                                                  onChange: _ctx.onChangeOption,
                                                                  label: ov.option,
                                                                  modelValue: ov.selected,
                                                                  "onUpdate:modelValue": ($event: any) => ((ov.selected) = $event)
                                                                }, null, 8, ["onChange", "label", "modelValue", "onUpdate:modelValue"])
                                                              ]),
                                                              _: 2
                                                            }, 1024),
                                                            (_ctx.stateTwo.catalogId && _ctx.state.catalog)
                                                              ? (_openBlock(), _createBlock(_component_el_col, {
                                                                  key: 0,
                                                                  span: 12
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createVNode(_component_el_select, {
                                                                      onChange: _ctx.onChangeOption,
                                                                      modelValue: ov.optionSet,
                                                                      "onUpdate:modelValue": ($event: any) => ((ov.optionSet) = $event),
                                                                      placeholder: `Select ${mpo.value}`
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.catalog[mpo.value], (cc) => {
                                                                          return (_openBlock(), _createBlock(_component_el_option, {
                                                                            key: cc,
                                                                            label: cc.name,
                                                                            value: cc.name
                                                                          }, null, 8, ["label", "value"]))
                                                                        }), 128))
                                                                      ]),
                                                                      _: 2
                                                                    }, 1032, ["onChange", "modelValue", "onUpdate:modelValue", "placeholder"])
                                                                  ]),
                                                                  _: 2
                                                                }, 1024))
                                                              : _createCommentVNode("", true)
                                                          ]),
                                                          _: 2
                                                        }, 1024))
                                                      }), 128))
                                                    ]))
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128)),
                                  _createElementVNode("div", {
                                    class: "text-right",
                                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSubmitMapping && _ctx.onSubmitMapping(...args)))
                                  }, [
                                    _createVNode(_component_el_button, { type: "primary" }, {
                                      default: _withCtx(() => [
                                        _hoisted_23,
                                        _hoisted_24
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_card, { class: "mt-3" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table, {
                ref: "multipleTable",
                data: _ctx.state.tableData,
                style: {"width":"100%"},
                onSelectionChange: _ctx.onSelectVariants
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "variant",
                    label: "Variant",
                    "min-width": "10"
                  }, {
                    default: _withCtx((scope) => [
                      _createTextVNode(_toDisplayString(scope.row.title), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "code",
                    label: "Catalog",
                    "min-width": "10"
                  }, {
                    default: _withCtx((scope) => [
                      (
                  scope.row.catalogs &&
                  scope.row.catalogs.length > 0 &&
                  scope.row.catalogs[0].catalogVariants &&
                  scope.row.catalogs[0].catalogVariants.length > 0
                )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(scope.row.catalogs[0].catalogName), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "code",
                    label: "Code",
                    "min-width": "10"
                  }, {
                    default: _withCtx((scope) => [
                      (
                  scope.row.catalogs &&
                  scope.row.catalogs.length > 0 &&
                  scope.row.catalogs[0].catalogVariants &&
                  scope.row.catalogs[0].catalogVariants.length > 0 &&
                  _ctx.getVariant(scope.row.catalogs[0].catalogVariants[0].code)
                )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(scope.row.catalogs[0].catalogVariants[0].code), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "cost",
                    label: "Cost",
                    "min-width": "10"
                  }, {
                    default: _withCtx((scope) => [
                      (
                  scope.row.catalogs &&
                  scope.row.catalogs.length > 0 &&
                  scope.row.catalogs[0].catalogVariants &&
                  scope.row.catalogs[0].catalogVariants.length > 0 &&
                  _ctx.getVariant(scope.row.catalogs[0].catalogVariants[0].code)
                )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.getVariant(scope.row.catalogs[0].catalogVariants[0].code).cost), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "designQty",
                    label: "Design Qty",
                    "min-width": "10"
                  }, {
                    default: _withCtx((scope) => [
                      (
                  scope.row.catalogs &&
                  scope.row.catalogs.length > 0 &&
                  scope.row.catalogs[0].catalogVariants &&
                  scope.row.catalogs[0].catalogVariants.length > 0 &&
                  scope.row.catalogs[0].catalogVariants[0].designQty
                )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(scope.row.catalogs[0].catalogVariants[0].designQty), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "designs",
                    label: "Designs",
                    "min-width": "10"
                  }, {
                    default: _withCtx((scope) => [
                      (
                  scope.row.catalogs &&
                  scope.row.catalogs.length > 0 &&
                  scope.row.catalogs[0].catalogVariants &&
                  scope.row.catalogs[0].catalogVariants.length > 0 &&
                  _ctx.getVariant(scope.row.catalogs[0].catalogVariants[0].code) &&
                  _ctx.state.catalog.variants.find(
                    s =>
                      s.catalogVariantCode ===
                      scope.row.catalogs[0].catalogVariants[0].code
                  ) &&
                  _ctx.state.catalog.variants.find(
                    s =>
                      s.catalogVariantCode ===
                      scope.row.catalogs[0].catalogVariants[0].code
                  ).designs.length > 0
                )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.catalog.variants.find(
                    s =>
                      s.catalogVariantCode ===
                      scope.row.catalogs[0].catalogVariants[0].code
                  ).designs, (item) => {
                              return (_openBlock(), _createElementBlock("p", { key: item }, _toDisplayString(item), 1))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.catalog.designs, (item) => {
                              return (_openBlock(), _createElementBlock("p", { key: item }, _toDisplayString(item.name), 1))
                            }), 128))
                          ]))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data", "onSelectionChange"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}